import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Card,
  Container,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import { resetFilters } from "../../redux/qr-credit-summary";
import DataSummaryCreditContainer from "../../components/qr-credit-summary/data-summary-credit.container";
import { ScanTrackSummaryDataContainer } from "../../components/scan-track-summary-data/scan-track-summary-data.container";
import StockoutSummary from "../../components/stockout-summary";

export default function DataSummaryContainer() {
  const dispatch = useDispatch();

  const [tabValue, setTabValue] = useState(0);
  const [activeSmartkoodButton, setActiveSmartkoodButton] =
    useState("qrCreditSummary");

  const handleTabChange = (_, newValue) => {
    setTabValue(newValue);
    setActiveSmartkoodButton("qrCreditSummary");
    dispatch(resetFilters());
  };

  const smartkoodButtons = [
    { label: "QR Credit Summary", key: "qrCreditSummary" },
  ];

  return (
    <Container maxWidth={false}>
      <Card sx={{ mb: 3, mt: 4 }}>
        <Typography variant="h4" sx={{ p: 3 }}>
          Data Summary
        </Typography>
      </Card>

      <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 3 }}>
        <Tab label="Smartkood Service" />
        <Tab label="Company" />
      </Tabs>

      {tabValue === 0 && (
        <Box sx={{ display: "flex", gap: 4 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              maxWidth: 300,
            }}
          >
            {smartkoodButtons.map(({ label, key }) => (
              <Button
                key={key}
                variant={
                  activeSmartkoodButton === key ? "contained" : "outlined"
                }
                onClick={() => setActiveSmartkoodButton(key)}
              >
                {label}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 1 }}>
            {activeSmartkoodButton === "qrCreditSummary" && (
              <DataSummaryCreditContainer />
            )}
          </Box>
        </Box>
      )}

      {tabValue === 1 && (
        <Box sx={{ mt: 2 }}>
          <ScanTrackSummaryDataContainer />
        </Box>
      )}

      {tabValue === 2 && (
        <Box sx={{ mt: 2 }}>
          <StockoutSummary />
        </Box>
      )}
    </Container>
  );
}
